import React from "react";
import { Link } from "react-router-dom";

// import SlideShow from "components/SlideShow";

import "./Home.scss";

import resources from "images/resources.png";
import primary from "images/primary1.svg";
import secondary from "images/secondary.svg";
import contact from "images/mailbox.svg";
import about from "images/kuba_information_icons_set_3.svg";

import edcity from "images/logo/edcity.png";
import edconvergence from "images/logo/edconvergence.jpg";

export default function HomePage() {
  return (
    <div className="Home">
      {/* <SlideShow /> */}

      <div className="Tiles columns is-multiline is-mobile">
        <div className="column is-three-fifths-tablet is-full-mobile">
          <div
            style={{ background: "#E2C61C" }}
            className="flex-row justify-center align-items-center is-full-width is-full-height"
          >
            <img alt="" src={resources} />
          </div>
        </div>

        <div className="column grid">
          <Link to="/primarytopics">
            <div className="is-relative is-full-height">
              <img src={primary} alt="" className="grid" />
              <div
                style={{ background: "#E0A4A4" }}
                className="is-grid-label is-size-4"
              >
                小學教材
              </div>
            </div>
          </Link>
        </div>

        <div className="column grid">
          <Link to="/secondarytopics">
            <div className="is-relative is-full-height">
              <img src={secondary} alt="" />
              <div
                style={{ background: "#4F90C5" }}
                className="is-grid-label is-size-4"
              >
                中學教材
              </div>
            </div>
          </Link>
        </div>
      </div>

      <div className="Tiles columns is-multiline is-mobile">
        <div className="column grid">
          <Link to="/contact">
            <div className="is-relative is-full-height">
              <img src={contact} alt="" />
              <div
                style={{ background: "#8FD0F1" }}
                className="is-grid-label is-size-4"
              >
                聯絡我們
              </div>
            </div>
          </Link>
        </div>
        <div className="column grid">
          <Link to="/about">
            <div className="is-relative is-full-height">
              <img src={about} alt="" />
              <div
                style={{ background: "#709F3D" }}
                className="is-grid-label is-size-4"
              >
                關於我們
              </div>
            </div>
          </Link>
        </div>
        <div className="column last is-three-fifths-tablet is-full-mobile">
          <div className="columns is-multiline is-mobile is-full-width is-full-height is-vcentered">
            <div className="column is-half">
              <a
                href="http://www.edconvergence.org.hk/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={edconvergence} alt="" />
              </a>
            </div>
            <div className="column is-half">
              <a
                href="https://www.hkedcity.net/home/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={edcity} alt="" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
